import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useViewport from 'utils/hooks/useViewport';

import { hideSnackbar } from 'redux/snackbar';

import { PORTAL } from 'utils/constants/variable';

import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export default function SnackbarAlert() {
  const { visible, content, severity } = useSelector((state) => state.snackbar);
  const { userFlow } = useSelector((state) => state.auth);

  const [state] = React.useState({
    vertical: 'bottom',
    horizontal: 'center',
    timeout: 10000
  });

  const { vertical, horizontal, timeout } = state;
  const dispatch = useDispatch();
  const { isDesktop } = useViewport();
  const isAlignmentRequired = userFlow === PORTAL.CUSTOMER && isDesktop;

  const handleClose = () => {
    dispatch(hideSnackbar());
  };

  return (
    <Snackbar
      className={isAlignmentRequired ? 'portal-ml-snackbar' : ''}
      autoHideDuration={timeout}
      anchorOrigin={{ vertical, horizontal }}
      open={visible}
      onClose={handleClose}>
      <MuiAlert
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
        elevation={6}
        variant="filled"
        severity={severity}>
        {content}
      </MuiAlert>
    </Snackbar>
  );
}
